import { NotificationType } from '@weave/schema-gen-ts/dist/shared/notification/notifications.pb';
import { FaxV1 } from '@frontend/api-fax';
import { useAppScopeSelection } from '@frontend/scope';
import { useWebsocketEventSubscription } from '@frontend/websocket';

export const useFaxReadEventSubscription = () => {
  const { updateFaxReadStatusInAllCaches } = FaxV1.FaxQueryUpdaters.useListFaxQueryUpdater();
  const { selectedLocationIds } = useAppScopeSelection();

  return useWebsocketEventSubscription(NotificationType.FAX_READ_STATUS_CHANGE, (payload) => {
    // BE will send fax events to all users - location agnostic,
    // so we need to check if the event is relevant to the user's selected locations before processing it.
    if (
      (!!payload.params.locationId && !selectedLocationIds.includes(payload.params.locationId)) ||
      !payload.params.faxId
    ) {
      return;
    }

    updateFaxReadStatusInAllCaches(payload.params.faxId, payload.params.markedRead ?? false);
  });
};
